<template>
  <button type="button" @click.prevent="toggle()">
    <sprite name="iconPause" title="Pause" v-if="playing" />
    <sprite name="iconPlay" title="Play" v-else />
  </button>
</template>

<script>
  export default {
    name: 'AudioButton',
    props: {
      src: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        playing: false
      }
    },
    mounted () {
      this.audio = new Audio(this.src)
      this.audio.onplaying = () => { this.playing = true }
      this.audio.onpause = () => { this.playing = false }
    },
    methods: {
      toggle () {
        if(this.playing) {
          this.audio.pause()
          this.audio.currentTime = 0
        }
        else {
          this.audio.play()
        }
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import "~globals";

  button {
    @include transition();
    @include size(4rem);
    border:1px solid $color-gray; border-radius:50%;
    &:hover, &:focus {
      border-color:$color-primary-darker;
      svg {
        fill:$color-primary-darker;
      }
    }
  }

  svg {
    @include transition();
    @include size(1.5rem);
    fill:$color-primary;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/audio-button.vue